// Utility function to handle smooth scrolling to sections
export const scrollToSection = (sectionId: string, offset: number = 100) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};

// Handle hash in URL on page load
export const handleHashScroll = (offset: number = 100) => {
  const hash = window.location.hash;
  if (hash) {
    const sectionId = hash.substring(1); // Remove the # symbol
    setTimeout(() => {
      scrollToSection(sectionId, offset);
    }, 100);
  }
};















